<template>
  <!--  /*铭记历史、致敬胜利*/-->
  <div class="Remember">
    <div class="contentnr">
      <div class="content-top-tab">
        <div class="content-top-tab-left">
          <div class="content-top-tab-zxs"  @click="handleTabQx('1')">这些事你该知道</div>
          <div class="content-top-tab-gdjn" @click="handleTabQx('2')">各地纪念活动</div>
        </div>
        <div class="content-top-tab-right" v-show="!luqh">
          <ul class="resistance-nav-region clearfix">
            <div class="whole" @click="handleCity('')">全部</div>
            <li v-for="(item,index) in regions" :key="index" :class="{'rdimgjj':index<=2}"
                @click="handleCity(item.orgId)" style="position: relative">
              <div v-show="index<=2" class="rdimg"></div>
              {{item.deptName}}
            </li>
            <div class="more" @click="moreregions=!moreregions">
              <span>更多</span>
              <div class="icon"></div>
              <div class="more-regions" v-show="moreregions">
                <ul class="clearfix roll">
                  <li v-for="(item,index) in regionslsit" :key="index" @click="handleCity(item.orgId)">{{item.deptName}}
                  </li>
                </ul>
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div class="content">
        <div class="content-listimg clearfix">
          <div class="top-li-title" v-show="luqh">
            <div class="listimg enlarge" @click="handleHerf(onetitle.basicId)"  :title=onetitle.basicTitle >
              <img  v-lazy= onetitle.basicThumbnail>
              <div class="list-one-title text-tow-overflow">{{onetitle.basicTitle}}</div>
            </div>
            <div class="listtitle">
              <div class="title-text roll" id="wtdata" @mouseenter.stop="mousewheeldd(true)"
                   @mouseleave.stop="mousewheeldd(false)">
                <ul class="title-text-list">
                  <li v-for="(item,index) in leftlmdata" :key="index">
                    <h3 v-html="item.basicTitle"   :title="item.basicTitle"></h3>
                    <p  :title="item.basicRoundup">
                      {{item.Roundup||item.basicRoundup}}
                      <span v-show="item.basicRoundup.length>120"  @click="handleHerf(item.basicId)" style="color: #40a9ff;font-size: 12px">[查看详情]</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul class="content-listimg-right clearfix">
            <li v-for="(item,index) in datalist" :key="index">
              <div class="listimg enlarge" @click="handleHerf(item.basicId)">
                <img v-lazy=item.basicThumbnail alt="">
              </div>
              <div class="listtitle" @click="handleHerf(item.basicId)">
                <div class="title-text " v-html="item.basicTitle" :title=item.basicTitle>
                </div>
              </div>
            </li>
            <div v-show="isdata" class="over">暂无数据</div>
          </ul>
          <paging v-show="!isdata" :dataall="screenthreepage.all" :dataCur="screenthreepage.cur"
                  :datanum="screenthreepage.num" :dataDatanum="screenthreepage.dataNum"
                  @change="pageChange"></paging>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import util from '@/assets/js/util'
  import Paging from '@/components/paging'
  import {GDNEWS, ZHEXIESHI} from '@/config/global.js'
  import {
    getzxsJsondata,
    getgdjnJsondata,
    getgdjnAjaxdata,
    getzctjJsondata,
    gethotareaJsondata,
    getzyJsondata
  } from '@/api/rememberhistory.js'

  export default {
    data() {
      return {
        ckge:"查看更多",
        leftlmdata: [],
        luqh: true,
        columnId: '',
        basicAreaCode: "",
        isdata: false,
        moreregions: false,
        screenthreepage: {
          all: '', //总页数
          cur: 1, //当前页码
          num: 6, //一页显示的数量  必须是奇数
          dataNum: '', //数据的数量
        },
        onetitle:{},
        screenthreedata: [],
        isdetails: false,
        datalist: [],
        regions: [],
        regionslsit: [],
        dqid: "1"
      }
    },
    mounted() {
      this.$on('bridge', (val) => {
        this.screenthreepage.cur = val
        if (this.datalist.length === 0) {
          this._initdata('1')
          this._handHoTarea()
          this._leftlmdata()
        }
      });
    },
    beforeUpdate() {
      this.$nextTick(()=>{
        $('.content-top-tab-left>div:nth-child(1)').addClass('xz-top')
        $('.content-top-tab-left>div').each(function () {
          $(this).click(function () {
            $('.content-top-tab-left>div').removeClass('xz-top')
            $(this).addClass('xz-top');
          })
        })
      })
    },
    components: {
      Paging,
    },
    methods: {
      _initdata(id) {
        if (id === "1") {
          this.columnId = ZHEXIESHI;
          this.dqid = id
          var data = []
          getzxsJsondata().then(res => {
              if (res.length > 0) {
                if (!util.isEmpty(res)) {
                  this.isdata = false;
                  data = res.slice(0, res.length)
                  this.screenthreedata = util.getJsonDetails(data, this.screenthreepage.num);
                  this.datalist = this.screenthreedata['1'];
                  this.datalist.forEach((item)=>{
                    let width = $('html').width()
                    if(width<=1366){
                      item.basicTitle = item.basicTitle.length>20?item.basicTitle.substring(0,20)+'...':item.basicTitle;
                    }else {
                      item.basicTitle = item.basicTitle.length>45?item.basicTitle.substring(0,45)+'...':item.basicTitle;
                    }
                  })
                  this.screenthreepage.dataNum = res[0].pageSize;
                  this.screenthreepage.all = Math.ceil(res[0].pageSize / this.screenthreepage.num)
                } else {
                  this.datalist=[]
                  this.isdata = true
                }
              } else {
                this.datalist=[]
                this.isdata = true
              }
            }
          ).catch((err) => {
            this.datalist=[]
            this.isdata = true

          })
        } else if (id === "2") {
          this.columnId = GDNEWS;
          var data = []
          getgdjnJsondata().then(res => {
              if (res.length > 0) {
                if (!util.isEmpty(res)) {
                  this.isdata = false;
                  data = res.slice(0, res.length)
                  this.screenthreedata = util.getJsonDetails(data, this.screenthreepage.num);
                  this.datalist = this.screenthreedata['1'];
                  var width = $('html').width()
                  this.datalist.forEach((item)=>{
                    if(width<=1366){
                      item.basicTitle = item.basicTitle.length>20?item.basicTitle.substring(0,20)+'...':item.basicTitle;
                    }else {
                      item.basicTitle = item.basicTitle.length>45?item.basicTitle.substring(0,45)+'...':item.basicTitle;
                    }
                  })
                  this.screenthreepage.dataNum = res[0].pageSize;
                  this.screenthreepage.all = Math.ceil(res[0].pageSize / this.screenthreepage.num)
                } else {
                  this.isdata = true
                  this.datalist=[]
                }
              } else {
                this.isdata = true
                this.datalist=[]
              }
            }
          ).catch((err) => {
            this.isdata = true
            this.datalist=[]
          })
        }
      },
      _leftlmdata() {
        getzctjJsondata().then(res => {
            if (res.length > 0) {
              if (!util.isEmpty(res)) {
                let data = res.slice(1, res.length)
                this.onetitle = res.slice(0, 1)[0];
                this.onetitle.basicTitle = this.onetitle.basicTitle.length>30?this.onetitle.basicTitle.substring(0,30):this.onetitle.basicTitle
                this.leftlmdata = data
                this.leftlmdata.forEach((item)=>{
                if(item.basicRoundup.length>130){
                   item.Roundup =  item.basicRoundup.substring(0,130)+"..."
                   this.ckge = "查看更多"
                  }
                })
              }
            }
          }
        ).catch((err) => {

        })
      },
      mousewheeldd(data) {
        this.$emit('mousewheelmr', data)
      },
      pageChange: function (page) {
        this.screenthreepage.cur = page;
        let data = {
          pageSize: this.screenthreepage.num,
          pageNum: this.screenthreepage.cur,
          columnId: ""
        };
        if (!this.screenthreedata[page] || this.screenthreedata[page].length < this.screenthreepage.num) {
          data.columnId = this.columnId;
          var width = $('html').width()
          getgdjnAjaxdata(data).then((res) => {
            if (res.code == 200 && res.rows) {
              if (res.rows.length > 0) {
                this.isdata = false
                this.datalist = res.rows;
                this.datalist.forEach((item)=>{
                  if(width<=1366){
                    item.basicTitle = item.basicTitle.length>20?item.basicTitle.substring(0,20)+'...':item.basicTitle;
                  }else {
                    item.basicTitle = item.basicTitle.length>45?item.basicTitle.substring(0,45)+'...':item.basicTitle;
                  }
                })
              } else {
                this.datalist=[]
                this.isdata = true
              }
            }
          }).catch(() => {
            this.datalist=[]
            this.isdata = true
          })
        } else {
          var width = $('html').width()
          this.datalist = this.screenthreedata[page];
          this.datalist.forEach((item)=>{
            if(width<=1366){
              item.basicTitle = item.basicTitle.length>20?item.basicTitle.substring(0,20)+'...':item.basicTitle;
            }else {
              item.basicTitle = item.basicTitle.length>45?item.basicTitle.substring(0,45)+'...':item.basicTitle;
            }
          })
        }
      },
      _handHoTarea() {
        gethotareaJsondata().then((res) => {
          this.regions = res.slice(0, 7)
          this.regionslsit = res.slice(7, 34);
        }).catch(() => {

        })
      },
      /*模拟数据*/
      /*  handmokecl(data) {
          this.regions = data.slice(0, 7)
          this.regionslsit = data.slice(7, 34);
        },*/
      handleHerf(id) {
        //直接调用$router.push 实现携带参数的跳转
        let routetele = this.$router.resolve({
          path: `/Details/${id}`,
        })
        window.open(routetele.href, '_blank');
      },
      handleCity(id) {
        let data = {
          columnId: this.columnId,
          basicAreaCode: id,
          pageSize: this.screenthreepage.num,
          pageNum: 1
        };
        var width = $('html').width()
        getgdjnAjaxdata(data).then((res) => {
          if (res.code == 200 && res.rows) {
            if (res.rows.length > 0) {
              this.isdata = false
              this.datalist = res.rows;
              this.datalist.forEach((item)=>{
                if(width<=1366){
                  item.basicTitle = item.basicTitle.length>20?item.basicTitle.substring(0,20)+'...':item.basicTitle;
                }else {
                  item.basicTitle = item.basicTitle.length>45?item.basicTitle.substring(0,45)+'...':item.basicTitle;
                }
              })
              this.screenthreepage.dataNum = res.total;
              this.screenthreepage.all = Math.ceil(res.total / this.screenthreepage.num)
            } else {
              this.datalist = []
              this.isdata = true
            }
          } else {
            this.datalist = []
            this.isdata = true
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleTabQx(id) {
        if (id == '1') {
          this.screenthreepage.num = 6;
          this.screenthreepage.cur = 1;
          this.luqh = true;
          $('.content-listimg-right').addClass('minwid')
          $('.content-listimg-right').removeClass('maxwid')
          this._initdata('1')
        } else if (id == '2') {
          this.screenthreepage.num = 10;
          this.screenthreepage.cur = 1;
          this.luqh = false;
          $('.content-listimg-right').removeClass('minwid')
          $('.content-listimg-right').addClass('maxwid')
          this._initdata('2')
        }
      },

    }
  }
</script>
<style scoped>
   @media screen and (max-width:1366px) {
     .title-text-list > li h3{
       font-size: 24px !important;
     }
     .title-text-list > li p{
       font-size: 22px !important;
     }
     .content-top-tab-left{
       width: auto !important;
       padding: 5px 8px !important;
     }
     .content-top-tab-left > div{
       font-size: 24px !important;
     }
     .content-listimg-bottom{
       font-size: 23px !important;
     }
     .list-one-title{
       font-size: 24px !important;
     }
     .top-li-title > div:nth-child(2){
       font-size: 36px !important;
     }
     .top-li-title > div:nth-child(2) > .title-text{
       font-size: 22px !important;
     }
     .content-listimg-left > h3{
       font-size: 32px !important;
     }
     .looking-forward > a, .memorial-service > a{
       font-size: 30px !important;
     }
     .listtitle{
       font-size: 24px !important;
       overflow: hidden;
       line-height: 35px !important;
     }
     .over{
       font-size: 34px !important;
     }
     .resistance-nav-region > .whole{
       font-size: 28px !important;
     }
     .resistance-nav-region > li{
       font-size: 20px !important;
     }
     .resistance-nav-region > .more{
       font-size: 20px !important;
     }
     .resistance-content ul li > .lstext{
       font-size: 25px !important;
     }
     .resistance-content ul li > .lstext > .region{
       font-size: 25px !important;
     }
    .content-listimg-right+.page-bar {
       bottom: -30px !important;
     }
   }

  .maxwid {
    width: 1306px !important;

  }
  .xz-top{
    background-color: red !important;
    color: white !important;
  }

  .minwid {
    width: 830px !important;
  }

  .title-text-list {

  }

  .title-text-list > li h3 {
    font-size: 16px;
    line-height: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .title-text-list > li p {
    font-size: 14px;
    line-height: 30px;
    text-indent: 2em;
    margin-bottom: 30px;
  }

  .title-text-list > li > span {
    text-align: right;
    display: inline-block;
    color: #40a9ff;
  }

  .contentnr {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .content-top-tab {
    margin-top: 50px;
    width: 1308px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-top-tab-left {
    display: flex;
    color: red;
  }

  .content-top-tab-left > div {
    padding: 8px 10px;
    cursor: pointer;
    background-color: #e5b882;
    border-radius: 4px;
    margin-right: 10px;
    font-weight: 700;
    font-size: 16px;
  }

  .content-top-tab-left > div:hover {
    background-color: red;
    color: white;
  }

  .Picture-list {
    width: 194px;
    height: 532px;
    float: left;
  }

  .content-listimg-left {
    position: relative;
    width: 194px;
    height: 600px;
    background: url("../../../assets/img/zhengji.png") no-repeat;
    background-size: 100% 100%;
  }

  .content-listimg-bottom {
    position: absolute;
    top: 200px;
    left: 17px;
    width: 168px;
    height: 69px;
    font-size: 14px;
    color: black;
    text-align: left;
  }

  .top-li-title {
    position: relative;
    height: 312px !important;
    width: 540px !important;
    -webkit-box-shadow: 0.005208rem 0.010417rem 0.03125rem 0 rgba(118, 103, 1, 0.35);
    box-shadow: 0.005208rem 0.010417rem 0.03125rem 0 rgba(118, 103, 1, 0.35)
  }

  .top-li-title > div:nth-child(1) {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .list-one-title{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: rgba(0,0,0,0.4);
    display: flex;
    justify-content: left;
    align-items: center;
    color: white;
    font-size: 16px;
    padding: 0 15px !important;
  }

  .top-li-title > div:nth-child(2) {
    width: 100%;
    height: 344px;
    font-size: 28px;
    color: white;
  }

  .top-li-title > div:nth-child(2) > .title-text {
    height: 100%;
    line-height: 50px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    color: black;
    overflow-y: scroll;
  }

  .content-listimg-left > h3 {
    position: absolute;
    top: 100px;
    left: 17px;
    width: 168px;
    height: 69px;
    font-size: 24px;
    font-family: Source Han Serif SC;
    font-weight: 800;
    color: rgba(225, 0, 0, 1);
  }

  .looking-forward, .memorial-service {
    width: 100%;
    height: 46px;
    margin-bottom: 20px;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    cursor: pointer;
    text-align: center;
  }

  .looking-forward > a, .memorial-service > a {
    font-size: 22px;
    display: inline-block;
    color: white;
    line-height: 46px;
    font-weight: 700;
  }

  .looking-forward:hover, .memorial-service:hover {
    background: url("../../../assets/img/bacbulr.png");
  }

  .looking-forward {
    background: url("../../../assets/img/bacred.png");
  }

  .looking-forward > span {
    display: inline-block;
    width: 32px;
    height: 80%;
    margin-bottom: 7px;
    background: url("../../../assets/img/zyicon.png");
    background-size: 100% 100%;
    vertical-align: bottom;
    margin-left: -10px;
    margin-right: 10px;
    margin-top: 3px;
  }

  .memorial-service {
    background: url("../../../assets/img/bacred.png");
  }

  .memorial-service > span {
    display: inline-block;
    width: 32px;
    height: 80%;
    margin-bottom: 7px;
    background: url("../../../assets/img/lsmb.png");
    background-size: 100% 100%;
    vertical-align: bottom;
    margin-left: -10px;
    margin-right: 10px;
    margin-top: 3px;

  }

  .content-listimg-right {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    float: left;
    width: 850px;
    height: 100%;
    min-height: 684px;
  }

  .content-listimg-right > li {
    float: left;
    margin-left: 10px;
    width: 250px;
    height: 312px;
    box-shadow: 1px 2px 6px 0px rgba(118, 103, 1, 0.35);
    margin-bottom: 30px;
  }

  .listimg {
    width: 100%;
    height: 155.5px;
    cursor: pointer;
  }

  .listimg img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .listtitle {
    position: relative;
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    height: 160px;
    padding: 19.7px;
    line-height: 26px;
    font-size: 16px;
    color: #000000;
    overflow: hidden;
    cursor: pointer;
    background-color: white;
  }
  .top-li-title > .listtitle{
    background: url("../../../assets/img/wtbj.png") ;
  }


  .title-text {
    overflow: hidden;
  }

  .listtitle:hover {
    color: #40A9FF;
  }

  .content-listimg {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    width: 1306px;
    position: relative;
    top: 20px;
  }

  .Remember {
    height: 100%;
    text-align: center;
    box-sizing: border-box;
  }

  .page-bar {
    bottom: -100px !important;
  }

  .content {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 100%;
  }

  .contentnr {
    width: 100%;
    float: left;
  }

  .top {
    position: relative;
    width: 100%;
    height: 226px;
  }

  .top > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1382px;
    height: 193px;
    background: url("../../../assets/img/tophongqi.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }

  .over {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    line-height: 500px;
    text-align: center;
    color: #aa0000;
    font-size: 25px;
  }

  .resistance-nav-region {
    display: flex;
    justify-content: space-between;
    float: left;
    margin-left: 67px;
    line-height: 36px;
  }

  .resistance-nav-region > .whole {
    float: left;
    width: 80px;
    height: 36px;
    font-size: 20px;
    line-height: 36px;
    font-family: Microsoft YaHei;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-right: 32px;
    background: url("../../../assets/img/whole.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }

  .resistance-nav-region > li {
    line-height: 36px;
    float: left;
    margin-right: 20px;
    color: #683e23;
    font-size: 17px;
    cursor: pointer;
  }

  .resistance-nav-region > li:hover {
    color: red;

  }

  .resistance-nav-region > .more {
    position: relative;
    float: left;
    line-height: 36px;
    font-size: 17px;
    color: #683e23;
    cursor: pointer;

  }

  .resistance-nav-region > .more > .icon {
    display: inline-block;
    background: url("../../../assets/img/more.png") no-repeat;
    width: 15px;
    height: 12px;
    background-size: 100% 100%;
    margin-top: 4.5px;
  }

  .resistance-nav-Refresh {
    float: left;
    margin-left: 40px;
    padding-top: 15px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .iconRefresh {
    line-height: 20px;
    width: 73px;
    height: 20px;
    background: url("../../../assets/img/iconRefresh.png");
    background-size: 100% 100%;
  }

  .resistance-content {
    position: relative;
    display: inline-block;
    text-align: center;
    width: 1382px;
  }

  .resistance-content ul {
    width: 100%;
    float: left;
  }

  .resistance-content ul li {
    float: left;
    width: 265px;
    height: 258px;
    margin-right: 13px;
    margin-top: 8px;
    background-image: url("../../../assets/img/xiangkuang.png");
    background-size: 100% 100%;
    overflow: hidden;
  }

  .resistance-content ul li:nth-child(5n) {
    margin-right: 0 !important;
  }

  .resistance-content ul li > .lsimg {
    width: 260px;
    height: 171px;
  }

  .resistance-content ul li > .lsimg > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .resistance-content ul li > .lstext {
    width: 260px;
    height: 87px;
    padding: 0 23px;
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
    font-size: 17px;
    line-height: 26px;
    color: #000000;
    text-align: left;
    cursor: pointer;
  }

  .resistance-content ul li > .lstext:hover {
    color: #40A9FF;
  }

  .resistance-content ul li > .lstext > .region {
    width: 100%;
    height: 16px;
    font-size: 17px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #000000;
    opacity: 0.67;
  }

  .more-regions {
    position: absolute;
    width: 500px;
    top: 40px;
    left: -330px;
    padding: 18px;
    padding-right: 9px !important;
    box-sizing: border-box;
    background-image: linear-gradient(
      #ffffff,
      #ffffff),
    linear-gradient(
      #ffe6c4,
      #ffe6c4);
    background-blend-mode: normal,
    normal;
    box-shadow: 3px 4px 14px 1px rgba(159, 97, 0, 0.5);
    border-radius: 8px;
    border: solid 1px #c2894c;
    z-index: 100000;
  }

  .more-regions ul {
    width: 100%;
    float: left;
    height: 270px;
  }

  .more-regions ul li {
    float: left;
    min-width: 37.5px;
    margin-right: 15px;
    margin-left: 5px;
    margin-bottom: 15px;
  }
  .rdimg{
    position: absolute;
    left: -20px;
    height: 25px;
    width: 25px;
    top: 0px;
    background: url("../../../assets/img/rd-huang.png");
    background-size: 100% 100%;
  }
  .rdimgjj {
    margin-right: 28px !important;
    padding-left: 5px;
  }

  .listwidth {
    width: 1306px !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home/components/remember.vue